/**
* 基础菜单 订单详情
*/
<template>
  <div class="contianer">
    <div class="flex_box">
      <div class="order_status">
        <p class="f14">售后类型</p>
        <p class="f20">{{detailData.service_type_text}}</p>
      </div>
      <div class="Delivery_warehouse">
        <p class="f14">售后状态</p>
        <p class="f20">{{Formatter(detailData.process_status)}}</p>
      </div>
      <div style="margin-left: 50px">
        <div class="order_no item f12" style="margin-top: 22px">
          <p class="color333">服务单号</p>
          <span class="color666">{{detailData.service_code}}</span>
        </div>
        <div class="order_no item f12">
          <p class="color333">提交时间</p>
          <span class="color666">{{detailData.create_time}}</span>
        </div>
      </div>
    </div>
    <!--列表-->
    <div class="table mt50">
      <p class="title f20 color333 fontWeight mb20">售后寄件物流信息</p>
      <div class="item f12">
        <span class="color666" style="color: #409EFF;margin-right: 20px" v-if="receiverLogsData.delivery_company_name">{{receiverLogsData.delivery_company_name}}</span>
        <p class="color333" style="margin-right: 5px">快递单号</p>
        <span class="color666">{{receiverLogsData.delivery_no}}</span>
      </div>
      <el-table size="small" :data="receiverLogsData.receiverLog" highlight-current-row v-loading="loading" border
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column   prop="create_time" label="时间" width="200">
        </el-table-column>
        <el-table-column   prop="log" label="内容" min-width="300" :show-overflow-tooltip='true'>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
  import {aftersaleDetail} from '../../api/basisMG'
  import {param} from '../../api/commonMG'
  import router from '../../router'

  export default {
    data() {
      return {
        code: '',
        serivceId:'',
        loading: false, //是显示加载
        detailData: {},
        ProcessStatus: [],
        receiverLogsData: {},
      }
    },
    // 注册组件
    components: {},
    /**
     * 创建完毕
     */
    created() {
      this.serivceId = this.$route.query.id
      if (this.$route.query.id) {
        localStorage.setItem('serivceId', this.$route.query.id)
        this.getdata(this.$route.query.id)
      }
      this.getParam('ProcessStatus')
    },
    mounted() {
      if (!this.serivceId) {
        this.getdata(localStorage.getItem('serivceId'))
      }
    },

    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 获取公司列表
      getdata(code) {
        this.loading = true
        aftersaleDetail(code)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.detailData = res.content.detail_info;
              if (res.content.receiver_log) {
                this.receiverLogsData = res.content.receiver_log
              }
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //过滤
      Formatter(value) {
        for (let item of this.ProcessStatus) {
          if (item.code == value) {
            return item.name
          }
        }
      },
      //获取系统字典
      getParam(type) {
        param(type)
          .then(res => {
            if (res.success) {
              this.ProcessStatus = res.content;
            }
          })
          .catch(err => {
          })
      },
      // 点击复制
      copy(name, phone, addr) {
        let url = name + ',' + phone + ',' + addr;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message({
          message: '复制成功',
          type: 'success'
        });
        oInput.remove()
      },
    }
  }
</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  .textCenter {
    text-align: center;
  }

  .mt50 {
    margin-top: 50px;
  }

  .mb20 {
    margin-bottom: 20px;
  }

  .f12 {
    font-size: 12px;
  }

  .f14 {
    font-size: 14px;
  }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .flex_box {
    display: flex;
  }

  .user-search {
    margin-top: 20px;
  }

  .breadcrumb {
    margin-bottom: 15px;
  }

  .userRole {
    width: 100%;
  }

  .order_status {
    margin-right: 55px;
  }

  .item {
    margin-right: 100px;
    margin-bottom: 10px;
  }

  .item .color333 {
    margin-right: 12px;
  }

  .item p {
    display: inline-block;
  }

  .image_box {
    margin-right: 30px;
  }

  .label {
    width: 120px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
  }

  .order_status, .Delivery_warehouse {
    margin-bottom: 20px;
    margin-top: 20px;
  }

  .order_status .f20 {
    margin-top: 4px;
    color: #409EFF;
    font-weight: 600;
  }

  .Delivery_warehouse .f20 {
    margin-top: 4px;
    color: #409EFF;
    font-weight: 600;
  }

  .shipping_information, .order_message {
    margin-bottom: 15px;
  }

  .shipping_information .title, .order_message .title {
    margin-right: 12px;
  }

  .image_box {
    display: flex;
    flex-direction: column;
  }

  .img_title {
    border: 1px solid #E4E7ED;
    border-top: 0;
    border-radius: 4px;
  }

  .copy {
    width: 20px;
    height: 20px;
    margin-left: 10px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }
  .table {
    width: 1500px;
  }
</style>





// WEBPACK FOOTER //
// src/views/supply/supplySaleDetail.vue